<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="apoderado-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putApoderado)">
          <ModalApoderados
            :complete="true"
            :options_facultades="options_facultades"
            :currentApoderado="currentApoderado"
            @submit.prevent
          />
        </form>
      </ValidationObserver>
    </b-modal>

    <h4 class="cardD">Representantes y Apoderados</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los apoderados.</label>

    <div class="row">
      <div class="col-12">
        <label for="">Apoderados</label>
        <b-table hover :fields="fieldsCuadroApoderados" :items="constitutiva.apoderados">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editApoderado(item)"
              :disabled="constitutiva.disabledComplementa"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <div class="mt-4">
      <div v-if="constitutiva.disabledComplementa === false">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="!canValidate">Continuar</b-button>
      </div>
      <div v-else>
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="constitutiva.disabledComplementa">
          Continuar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalApoderados from "@/views/clients/procesos/constitucion/infoBase/modales/ModalApoderados.vue";

import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "Apoderados",

  computed: {
    fieldsCuadroApoderados() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },
  },

  created() {
    this.getFacultades();
    this.enableSave();
  },

  watch: {
    "constitutiva.apoderados": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
  },

  components: {
    ModalApoderados,
  },

  props: {
    constitutiva: { type: Object },
    cat_facultades: { type: Array },
  },

  data() {
    return {
      loading: false,
      canValidate: false,

      options_facultades: [],

      currentApoderado: null,
      currentApoderadoId: null,
    };
  },

  methods: {
    formatCurrency,

    enableSave() {
      let count = 0;
      this.constitutiva.apoderados.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      if (count === 0) {
        this.canValidate = true;
      } else {
        this.canValidate = false;
      }
    },

    getFacultades() {
      try {
        this.loading = true;

        this.options_facultades = this.cat_facultades.map(({ facultad }) => ({
          text: facultad,
          value: facultad,
        }));
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    editApoderado(item) {
      this.currentApoderado = item;
      this.$refs["apoderado-modal"].show();
    },

    putApoderado() {
      if (!this.currentApoderado.id) {
        let id = this.constitutiva.apoderados.length + 1;
        this.currentApoderado.id = id;
        var a = Object.assign({}, this.currentApoderado);
        this.constitutiva.apoderados.push(a);
      } else {
        let index = this.constitutiva.apoderados.findIndex((o) => o.id === this.currentApoderado.id);
        var a = Object.assign({}, this.currentApoderado);
        // this.constitutiva.apoderados[index] = a;
        this.constitutiva.apoderados.splice([index], 1, a);
      }

      this.$refs["apoderado-modal"].hide();
    },
  },
};
</script>

<style scoped>
.completado_green {
  background-color: yellowgreen !important;
}

.completado_yellow {
  background-color: gold !important;
}
</style>
